import { apiClient } from "../config";

async function deleteRole(id: any) {
  const res = await apiClient.delete(`/admin/roles/${id}`);
  return res.data;
}

export default deleteRole;
